// extracted by mini-css-extract-plugin
export default {"matchRowContent":"_1tMzF","matchRow":"_1xUam","innerLineContainer":"_2t5SX","detailsCell":"_3Gi6d","mainLineStakes":"_1Ladr"};